import React from 'react';
import { TaggedInLabelProps } from '../type';

const TaggedInLabel: React.FC<TaggedInLabelProps> = ({ text }) => {
  const taggedInUsers = (text || '').match(/@(\w+)/g) || [];

  return (
    <div>
      {taggedInUsers.length > 0 ? (
        taggedInUsers.map((user, index) => (
          <span key={index} style={{ marginRight: '5px' }}>
            {user}
          </span>
        ))
      ) : (
        <span>-</span>
      )}
    </div>
  );
};

export default TaggedInLabel;
